export default __webpack_public_path__ + "static/media/Logo.ff8a0bb9.png";